<script lang="ts">
	/**
	 * Search (+ optional filter) chrome for list kebabs on mobile/tablet.
	 * Bound via `$listHeader.search` so Devices / Scenes / Groups can share one UI.
	 */
	import { Input, IconButton } from '@Shelly/shelly-design-system';
	import type { ListHeaderSearchConfig } from 'src/stores/list_header';

	export let search: ListHeaderSearchConfig;
	export let className = 'mb-m';

	let localValue = '';

	$: localValue = search.value;

	const commit = () => {
		if (localValue !== search.value) search.onInput(localValue);
	};
</script>

<div class="d-flex align-items-center list-header-search {className}">
	<Input
		class="flex-1 min-width-0 mr-s text-capitalize-placeholder"
		bind:value={localValue}
		type="text"
		label={search.label ?? 'Search'}
		icon="fas fa-search"
		id={search.id ?? 'list-header-search-input'}
		aria-labelledby={search.id ?? 'list-header-search-input'}
		on:input={commit}
	/>
	{#if search.filter}
		<IconButton
			disabled={search.filter.disabled}
			icon="fa-solid fa-filter"
			on:click={() => search.filter?.onClick()}
			aria-label={search.filter.ariaLabel ?? 'Open filter'}
			notification={search.filter.notification as any}
		/>
	{/if}
</div>
